import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { update } from 'api/modifiers';
import { fetchModifierGroups } from 'slices/modifierGroups';
import { selectCurrentLocationId } from 'slices/account';

const NAME = 'modifiers';

const initialState = {
  loading: false,
  error: null,
  modifiers: [],
  modifiersDialogVisible: false,
};

export const updateModifier = createAsyncThunk(
  'modifiers/update',
  async (payload, thunkAPI) => {
    try {
      const { dispatch } = thunkAPI;
      const { id, groupId, body } = payload;
      const { getState } = thunkAPI;
      const locationId = selectCurrentLocationId(getState());
      const modifier = await update({
        id, groupId, locationId, dispatch,
      })(body);
      dispatch(fetchModifierGroups());
      return modifier;
    }
    catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const slice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setModifiersDialogVisible: (state, action) => {
      state.modifiersDialogVisible = action.payload;
    },
  },
  extraReducers: {
    [updateModifier.pending]: (state) => {
      state.loading = true;
    },
    [updateModifier.fulfilled]: (state, action) => {
      const modifiers = action.payload;
      state.modifiers = modifiers;
      state.loading = false;
      state.error = null;
    },
    [updateModifier.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },

});

export const { setModifiersDialogVisible } = slice.actions;

export const selectModifiers = (state) => state[NAME].modifiers;
export const selectModifiersLoading = (state) => state[NAME].loading;
export const selectModifiersDialogVisible = (state) => state[NAME].modifiersDialogVisible;

export default slice.reducer;
